<div class="row">
    <div class="col-xs-12 data-table-header">
        <ng-content select="app-data-filters"></ng-content>

        <ng-content select="app-data-buttons"></ng-content>
    </div>
    <div class="col-xs-12 data-table-header">
        <ng-content select="[subBar]"></ng-content>
        <div id="select-columns" class="m-l-sm" *ngIf="showColumnsSelection">
            <app-dropdown-button [smallPadding]="true" [btnIconClass]="'fa fa-columns'" [btnClasses]="'btn-default btn-outline'" [large]="false" [small]="true">
                <li app-dropdown-button-item *ngFor="let column of columns" [class.hidden]="column.notHideable"
                    [hasCheckbox]="true">
                    <label>
                        <input type="checkbox" [(ngModel)]="column.displayed" (change)="onColumnFilterChange(column)">
                        <i class="fa checkbox-icon"></i>
                        <span [i18n]="[{target: 'innerHTML', key: column.translationKey}]"></span>
                    </label>
                </li>
            </app-dropdown-button>
        </div>
    </div>
</div>

<div class="row">
    <div class="col-md-12" [ngClass]="{'tableHeadSticky': headSticky}">
        <div class="ibox float-e-margins">
            <div class="ibox-content no-padding">
                <div class="table-responsive" [class._noOverflow]="noOverflow" [class._lightSkin]="lightSkin">
                    <table class="table table-striped text-left" [ngClass]="{ 'selectable': allowItemSelection}">
                        <thead>
                        <tr>
                            <ng-container *ngFor="let column of columns">
                                <th *ngIf="column.displayed && column.selectColumn && column.onSelect"
                                    width="{{column.widthCol}}"
                                    [ngClass]="{ 'pointer': column.sortable, 'active': column === sortColumn, 'force-text-right': column.alignRight, 'force-text-center': column.alignCenter }">
                                    <div class="checkbox">
                                        <label>
                                            <input type="checkbox"
                                                   (change)="column.onSelect($event.currentTarget.checked)">
                                            <i class="fa checkbox-icon"></i>
                                            <span *ngIf="column.translationKey" [i18n]="column.translationKey"></span>
                                        </label>
                                    </div>
                                </th>
                                <th *ngIf="column.displayed && !column.sortable && !column.selectColumn"
                                    width="{{column.widthCol}}"
                                    [ngClass]="{ 'pointer': column.sortable, 'active': column === sortColumn, 'force-text-right': column.alignRight, 'force-text-center': column.alignCenter }">
                                    <ng-container *ngIf="column.customTitleTemplate"
                                                  [ngTemplateOutlet]="column.customTitleTemplate">
                                    </ng-container>
                                    <ng-container *ngIf="!column.customTitleTemplate">
                                        <span [i18n]="[{target: 'innerHTML', key: column.translationKey}]"></span>
                                    </ng-container>
                                </th>
                                <th *ngIf="column.displayed && column.sortable" (click)="sort(column)"
                                    width="{{column.widthCol}}"
                                    class="pointer"
                                    [ngClass]="{ 'active': column === sortColumn, 'force-text-right': column.alignRight, 'force-text-center': column.alignCenter }">
                                    <span [i18n]="[{target: 'innerHTML', key: column.translationKey}]"></span>

                                    <i *ngIf="column.sortable" class="fa"
                                       [ngClass]="direction === SortDirection.DESC ? 'fa-arrow-down' : 'fa-arrow-up'"></i>
                                </th>
                            </ng-container>
                        </tr>
                        </thead>
                        <tbody infiniteScroll [infiniteScrollThrottle]="1000" [infiniteScrollDistance]="0"
                               [infiniteScrollDisabled]="!infiniteScroll" (scrolled)="onScroll()">

                        <ng-container *ngFor="let i of items; index as index">


                            <!---- STANDARD ROWS IN TABLE ------->

                            <tr (click)="selectOnRowClick ? selectItem(i) : true" class="table-row"
                                [ngClass]="{ 'selected': isSelected(i) }">
                                <ng-template ngFor [ngForOf]="columns" let-column>
                                    <td *ngIf="column.displayed"
                                        [ngClass]="{ 'overflow-visible': column.overflowVisible }">
                                        <app-data-table-column (selectItem)="selectItem(i)" [template]="column.template"
                                                               [item]="i" [selected]="isSelected(i)"
                                                               [alignRight]="column.alignRight"
                                                               [alignCenter]="column.alignCenter"
                                                               [index]="index">
                                        </app-data-table-column>
                                    </td>
                                </ng-template>
                            </tr>


                            <!---- SUB ROWS FOR ITEM  ------->
                            <!---- Defined in each item's "additionalInfoKey" field  ------->
                            <!---- and template "additionalRowTemplate"  ------->

                            <tr class="loadDetailsColumn" *ngIf="additionalRowTemplate &&
                                                                 i[additionalInfoKey] &&
                                                                 i[additionalInfoKey].length > 0 &&
                                                                 isSelected(i)">
                                <td [attr.colspan]="columns.length">
                                    <div class="loadDetailsColumn-content">
                                        <table>
                                            <tbody>
                                            <ng-container *ngFor="let r of i[additionalInfoKey]; index as index">
                                                <tr>
                                                    <ng-template [ngTemplateOutlet]="additionalRowTemplate"
                                                                 [ngTemplateOutletContext]="{info: r, index: index}"></ng-template>
                                                </tr>
                                            </ng-container>
                                            </tbody>
                                        </table>
                                    </div>
                                </td>
                            </tr>

                            <!---- ADDITION INFORMATION FOR ITEM  ------->
                            <!---- Doesn't have to be list, hole item is passed to template  ------->
                            <!---- Template "additionalRowTemplate"  ------->


                            <tr class="etaDetailsColumn" *ngIf="additionalRowTemplate &&
                                                                !additionalInfoKey &&
                                                                 isSelected(i)">
                                <td class="etaDetailsColumn-content" [attr.colspan]="columns.length">
                                    <ng-template [ngTemplateOutlet]="additionalRowTemplate"
                                                 [ngTemplateOutletContext]="{item: i}"></ng-template>
                                </td>
                            </tr>
                        </ng-container>


                        <!---- NO DATA PLACEHOLDER  ------->

                        <tr *ngIf="items?.length === 0">
                            <td [attr.colspan]="columns.length" class="force-text-center">
                                <em [i18n]="noResultLabelKey"></em>
                            </td>
                        </tr>


                        </tbody>
                    </table>

                    <div class="table-footer" *ngIf="!infiniteScroll && !hidePageSelector">
                        <span class="inner-space-left-10">
                            <app-ajax-pagination [page]="page" [pageSize]="pageSize" [lastPage]="lastPage"
                                                 (pageChange)="changePage($event)"></app-ajax-pagination>
                        </span>
                        <span class="inner-space-right-10 footer-control">
                            <select [(ngModel)]="pageSize" class="form-control size-select" (change)="changePage(1)">
                                <option *ngFor="let size of pageSizeOptions" [ngValue]="size">{{ size }}</option>
                            </select>
                            <span class="entries-count"
                                  [i18n]="[{target: 'innerHTML', key: 'data-table.count', params: { count: totalCount}}]"></span>
                        </span>

                    </div>
                </div>

            </div>
        </div>
    </div>
</div>
